import {rowSlide} from "./module/slide";
import floating from './module/floating';

//表のハイライト
function tableHighlight() {
	let thTmpColor;
	let tdTmpColor;
	let thHighLightColor = '#9A9A9A';
	let tdHighLightColor = '#F4F4F4';
	let tmpIdx;
	const tableRows = $('.page-comparison-table tbody tr');

	function highlightRow() {
		thTmpColor = $(this).find('th').css('background-color');
		tdTmpColor = $(this).find('td').css('background-color');
		tmpIdx = tableRows.index(this);
		tableRows.eq(tmpIdx).find('th').css('background', thHighLightColor);
		tableRows.eq(tmpIdx).find('td').css('background', tdHighLightColor);
	}

	function unhighlightRow() {
		tableRows.eq(tmpIdx).find('th').css('background', thTmpColor);
		tableRows.eq(tmpIdx).find('td').css('background', tdTmpColor);
	}

	if(window.innerWidth > 767) {
		tableRows.hover(highlightRow, unhighlightRow);
	} else {
		tableRows.on('click', function(e) {
			e.preventDefault();

			tableRows.not(this).each(function() {
				unhighlightRow.call(this);
				$(this).removeClass('highlighted');
			});

			if ($(this).hasClass('highlighted')) {
				$(this).removeClass('highlighted');
				unhighlightRow.call(this);
			} else {
				tableRows.removeClass('highlighted');
				$(this).addClass('highlighted');
				highlightRow.call(this);
			}
		});
	}
}

//比較画面 表の移動、削除ボタン
function moveDeleteBtn() {
	$('.page-comparison-move-right-btn').on('click', function(){
    const $cell = $(this).parents('td');
    const colIndex = $cell.index();
    $cell.closest('table').find('tr').each(function(){
      $(this).find('td').eq(colIndex - 1).insertAfter($(this).find('td').eq(colIndex));
    });
  });

  $('.page-comparison-move-left-btn').on('click', function(){
    const $cell = $(this).parents('td');
    const colIndex = $cell.index();
    $cell.closest('table').find('tr').each(function(){
      $(this).find('td').eq(colIndex - 1).insertBefore($(this).find('td').eq(colIndex - 2));
    });
  });

  $('.page-comparison-delete-btn').on('click',function() {
    const index = $(this).closest('td').index();
    $('td:nth-child(' + (index + 1) + ')').remove();
  });
}

//検索結果 フローティングの最小・最大化
function accFloatingProduct() {
	const $floatingAccBtn = $('.p-product-floating__acc-btn');
	const $floatingAccText = $('.p-product-floating__acc-txt');
	const $floating = $('.p-product-floating');

	$floatingAccBtn.on('click',function(){
		$(this).toggleClass('is-active');
		$floating.toggleClass('is-minimize');

		if($(this).hasClass('is-active')) {
			$floatingAccText.text('最大化して表示');
			setFloatingHeight(-25);
		}else {
			$floatingAccText.text('最小化して表示');
			setFloatingHeight(25);
		}
	});
}

//カテゴリから検索 SP用並び替え調整
function deleteParent() {
	if(window.innerWidth < 767) {
		const parentElem = $('.page-product-top-panel').parent();
		for (let i = 0; i < parentElem.length; i++) {
			while (parentElem[i].firstChild) {
				parentElem[i].before(parentElem[i].firstChild);
			}
			parentElem[i].remove();
		}
	}
}

//フローティングの高さ
const setFloatingHeight = (adjust) => {
	const $floating = $('.js-floating');
	const floatingH = $floating.outerHeight();
	$('html').css('--floating-height', floatingH + adjust + 'px');
}

$(window).on('load', function() {
	if($('.js-floating').length) {
		setFloatingHeight(0);
	}
});

$(function() {
	if($('.page-product-top-panels').length) {
		deleteParent();
	}

	if($('.page-comparison-table').length) {
		tableHighlight();
		moveDeleteBtn();
	}

	if($('.js-slider-row-01').length) {
		rowSlide('.js-slider-row-01',2,4,'.prev-btn-01','.next-btn-01');
	}

	if($('.js-slider-row-02').length) {
		rowSlide('.js-slider-row-02',2,4,'.prev-btn-02','.next-btn-02');
	}

	if($('.js-floating').length) {
		floating('.page-product-links');
		accFloatingProduct();
	};
})

if($('.js-slider-product').length) {
	let options = {
		loop: false,
		centeredSlides: false,
		slidesPerView: 1.5,
		spaceBetween: 8,
		speed: 1000,
		navigation: {
			nextEl: '.p-product-floating__slide .swiper-button-next',
			prevEl: '.p-product-floating__slide .swiper-button-prev',
		},
		breakpoints: {
			768: {
				slidesPerView: 2.3,
			},
			880: {
				slidesPerView: 3.3,
			},
			1280: {
				slidesPerView: 5.3,
			}
		}
	}

	const productSlider = document.querySelector('.js-slider-product');
	const initSlide = () => {
		new Swiper(productSlider, options);
	}

	initSlide();
}

if($('.p-product-detail-gallery').length) {
	const mySwiper_thumb = new Swiper('.p-product-detail-gallery__thumb .swiper', {
		slidesPerView: 3,
		spaceBetween: 14,
		navigation: {
			nextEl: '.p-product-detail-gallery .swiper-button-next',
			prevEl: '.p-product-detail-gallery .swiper-button-prev',
		},
	});

	const mySwiper_main = new Swiper('.p-product-detail-gallery__main .swiper', {
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		speed: 500,
		thumbs: {
			swiper: mySwiper_thumb,
		},
	});
}
